import React, { useState, useEffect, useContext } from "react";
import { UserContext } from "../UserContext";
import { useNavigate } from "react-router-dom";
import Footer from "../Footer";
import AdminNav from "../Navbars/AdminNav";
import axios from "axios";
import { toast } from "react-toastify";
import "./RedeemRequest.css";
import axiosInstance from "./axiosInstance";

function RedeemRequest() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState("All");

  const { isAdmin, setUserRole, setUserInfo, userInfo } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserInfo();
    fetchRedeemRequests();
  }, []);

  const fetchUserInfo = async () => {
    try {
      const response = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`, {
        credentials: "include",
      });
      const data = await response.json();
      setUserInfo(data);
      if (data?.usertype) {
        setUserRole(data.usertype);
      }
    } catch (error) {
      console.log("Error in fetchUserInfo:", error);
    }
  };

  const fetchRedeemRequests = () => {
    setLoading(true);
    axiosInstance.get("/getRedeemRequests")
      .then((response) => {
        setRequests(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching redeem Request:", error);
        toast.error("Failed to load redeem Request", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setLoading(false);
      });
  };
  const handleStatusChange = (Gift_id, newStatus, student_id) => {
    setLoading(true);
    axiosInstance.put(`/updateRedeemStatus/${Gift_id}/${student_id}`, { status: newStatus })
      .then((response) => {
        toast.success("Status updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
        fetchRedeemRequests(); // Refresh the list
      })
      .catch((error) => {
        console.error("Error updating status:", error);
        toast.error("Failed to update status", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleStatusFilter = (status) => {
    setFilterStatus(status);

  };
  let filteredRequests = filterStatus === "All"
    ? requests
    : requests.filter(item => item.status.toLowerCase() === filterStatus.toLowerCase());


  const formatDate = (dateString) => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const onLogout = () => {
    fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: "include",
      method: "POST",
    })
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        console.error("Logout failed:", error);
      });
    setUserInfo(null);
    setUserRole("guest");
  };

  const username = userInfo?.username;

  return (
    <>
      {username && isAdmin && <AdminNav username={username} onLogout={onLogout} />}

      <div className="redeem-request-containers">
        <h2 className="page-titles">Redeem Requests</h2>

        <div className="filter-controlss">
          <div className="status-filterss">
            <button
              className={filterStatus === "All" ? "active" : ""}
              onClick={() => handleStatusFilter("All")}
            >
              All
            </button>
            <button
              className={filterStatus === "Open" ? "active" : ""}
              onClick={() => handleStatusFilter("Open")}
            >
              Open
            </button>
            <button
              className={filterStatus === "In Process" ? "active" : ""}
              onClick={() => handleStatusFilter("In Process")}
            >
              In Process
            </button>
            <button
              className={filterStatus === "Delivered" ? "active" : ""}
              onClick={() => handleStatusFilter("Delivered")}
            >
              Delivered
            </button>
          </div>
        </div>

        <div className="request-table-container">
          {loading ? (
            <div className="loading-spinner">Loading...</div>
          ) : (
            <table className="request-table">
              <thead>
                <tr>
                  <th>Gift Name</th>
                  <th>Student Name</th>
                  <th>Request Time</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredRequests.length > 0 ? (
                  filteredRequests.map((request, i) => (
                    <tr key={i}>
                      <td>{request.giftname}</td>
                      <td>{request.student_name}</td>
                      <td>{formatDate(request.redeemtime)}</td>
                      <td>
                        <select
                          value={request.status}
                          onChange={(e) => handleStatusChange(request.gift_id, e.target.value, request.Student_id)}
                          className={`status-select ${request.status.replace(" ", "-").toLowerCase()}`}
                        >
                          <option value="Open">Open</option>
                          <option value="In Process">In Process</option>
                          <option value="Delivered">Delivered</option>
                        </select>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="no-data">No redeem requests found</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default RedeemRequest;